import type { ModuleDefinitionViewModel } from '@/models/module-definition-view-model';
import type { EntityDefinitionViewModel } from '@/models/entity-definition-view-model';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

export const moduleDefinitionsQueryOptions = queryOptions({
  queryKey: ['module-definitions'],
  queryFn: async () => {
    const response = await axios.get<ModuleDefinitionViewModel[]>(
      '/module-definitions'
    );
    if (response.status !== 200) {
      throw new Error('Failed to fetch module definitions');
    }

    const modules = response.data;

    // Enhance each module with its submodule entities
    const enhancedModules = modules.map((module) => {
      const currentModuleEntities = module.entityDefinitions || [];

      // Find submodules that belong to this module
      const subModules = modules.filter((m) => m.parentModuleId === module.id);

      // Collect all entity definitions from submodules
      const subModuleEntities = subModules.reduce<EntityDefinitionViewModel[]>(
        (acc, subModule) => {
          if (subModule.entityDefinitions) {
            acc.push(...subModule.entityDefinitions);
          }
          return acc;
        },
        []
      );

      // Return enhanced module with combined entity definitions
      return {
        ...module,
        entityDefinitions: [...currentModuleEntities, ...subModuleEntities],
      };
    });

    return enhancedModules;
  },
});
